import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 541 321",
  preserveAspectRatio: "none",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g filter=\"url(#filter0_b_14_33)\"><path d=\"M0 321H541V12C541 5.37259 535.627 0 529 0H12C5.37259 0 0 5.37258 0 12V321Z\" fill=\"black\" fill-opacity=\"0.08\"></path></g><path d=\"M0 321H541V-7.62939e-06H0V321Z\" fill=\"url(#paint0_radial_14_33)\"></path><path d=\"M0 321H541V-7.62939e-06H0V321Z\" fill=\"url(#paint1_linear_14_33)\" fill-opacity=\"0.26\"></path><path d=\"M0 321H541V-7.62939e-06H0V321Z\" fill=\"black\" fill-opacity=\"0.2\"></path>", 4)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<filter id=\"filter0_b_14_33\" x=\"-104\" y=\"-104\" width=\"749\" height=\"529\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feGaussianBlur in=\"BackgroundImage\" stdDeviation=\"52\"></feGaussianBlur><feComposite in2=\"SourceAlpha\" operator=\"in\" result=\"effect1_backgroundBlur_14_33\"></feComposite><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_backgroundBlur_14_33\" result=\"shape\"></feBlend></filter>", 1)
const _hoisted_7 = {
  id: "paint0_radial_14_33",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(193) rotate(77.613) scale(328.651 551.531)"
}
const _hoisted_8 = ["stop-color"]
const _hoisted_9 = ["stop-color"]
const _hoisted_10 = ["stop-color"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("linearGradient", {
  id: "paint1_linear_14_33",
  x1: "258.5",
  y1: "224.319",
  x2: "261.676",
  y2: "-0.00459834",
  gradientUnits: "userSpaceOnUse"
}, [
  /*#__PURE__*/_createElementVNode("stop"),
  /*#__PURE__*/_createElementVNode("stop", {
    offset: "1",
    "stop-opacity": "0"
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("defs", null, [
      _hoisted_6,
      _createElementVNode("radialGradient", _hoisted_7, [
        _createCommentVNode(" Set colors "),
        _createElementVNode("stop", {
          "stop-color": 
            this.colors && this.colors.length == 2 ? this.colors[0] : '#3b3b3b'
          ,
          class: "transition-all duration-700"
        }, null, 8 /* PROPS */, _hoisted_8),
        _createElementVNode("stop", {
          offset: "0.543463",
          "stop-color": 
            this.colors && this.colors.length == 2 ? this.colors[1] : '#1f1f1f'
          ,
          class: "transition-all duration-700"
        }, null, 8 /* PROPS */, _hoisted_9),
        _createElementVNode("stop", {
          offset: "0.937639",
          "stop-color": 
            this.colors && this.colors.length == 2 ? this.colors[1] : '#1f1f1f'
          ,
          class: "transition-all duration-700"
        }, null, 8 /* PROPS */, _hoisted_10)
      ]),
      _hoisted_11
    ])
  ]))
}